<template>
      <div class="content">
          <a-row :gutter="[16,16]">
              <a-col :span='24' style="padding:0 8px;">
                  <div class="titleBox">
                    <div class="pageTitle">今日概况(今日0点 ~ {{todayN}}点)</div>
                    <a-button class="titleBtn" type="primary" style="float:right;margin-top:2px;" @click="handleSub">添加关注系统</a-button>
                    <sysselecter :modalState="modalState" @onModalHide="handleModalHide"></sysselecter>
                  </div>
              </a-col>
          </a-row>
          <sumP :data="sumData"></sumP>
          <a-row :gutter="[16,16]">
              <a-col :span='12'>
                  <qschart :data="sumData" :chartID="'overviewschart'" @qschartCLick = "handleChartClick"></qschart>
              </a-col>

              <a-col :span='12'>
                  <zbpie :data="sumData"></zbpie>
              </a-col>
          </a-row>
            <a-row :gutter="[16,16]">
              <a-col :span='24' style="padding:0 8px;">
                  <div class="titleBox">
                    <div class="pageTitle">关注系统一览</div>
                    <timeSelecter style="margin-left:20px;" :dataflag="true"  ref="overviewTimeRange" @timeChanged="handleTimeChange"></timeSelecter>

                    <a-button class="searchItem" style="margin-left:20px;" type="primary" @click="handleSubmit">查询</a-button>

                  </div>
              </a-col>
          </a-row>
          <a-row :gutter="[16,16]">
              <a-col :span='24'>
                  <mtable :folowsData="sumData" ref="myFolowTable"></mtable>
              </a-col>
          </a-row>
      </div>
</template>

<script>
import sumP from './sum'
import qschart from './qschart'
import zbpie from './zbpie'
import mtable from './table'
import sysselecter from './sysselecter'
import timeSelecter from '../logtimeselecter'
export default {
    data(){
        return {
            
            sumData:{
                SysCount:{
                    lastdaycount: "",
                    todaycount: ""
                },
                MsgCount:{
                    lastdaymsgcount: "",
                    todaymsgcount: ""
                },
                ClassCount:{
                    lastdayclasscount: "",
                    todayclasscount: ""
                },
                SumCount:{
                    lastdaysumcount: "",
                    todaysumcount: ""
                },
                listerrorsys:[],
                listthread:[],
                syslist:[],
                listfolows:[],
                isoverview:true,
                isperhour:true,
            },
            todayN:(new Date()).Format("hh"),
            modalState: {
                isShow: false,
                syslist:[],
                listfolows:[],
            },
            table_loading:false,
            currentTrange:'',
            timeType:9,
        }
    },
    methods:{
        handleTimeChange(tRange,timeType){
            this.currentTrange = tRange;
            this.timeType = timeType;
        },
        handleChartClick(targetDate){
            console.log(targetDate)
            let targetEnd = new Date(new Date(targetDate).getTime() + 60 * 60 * 1000).Format('yyyy-MM-dd hh:mm:ss');
            this.$refs.overviewTimeRange.setTimeRange(targetDate,targetEnd);
            this.handleSubmit();
        },
        handleSubmit(){
            if(this.$refs.myFolowTable.tLoading){
                return;
            }
            this.$refs.myFolowTable.getFolowData(this.currentTrange,this.sumData.listfolows,this.timeType)
        },

        //添加关注系统
        handleSub(){
            this.modalState.syslist = this.sumData.syslist;
            this.modalState.listfolows = this.sumData.listfolows;
            this.modalState.isShow = true;

        },
        handleModalHide(selectSys){
            if(this.modalState.listfolows != selectSys){
                //如果选择关注系统发生变化,关注系统发生变化，强制刷新
                this.getOverview(true);

            }
            this.modalState.isShow = false;
        },
        getOverview(isFource){
            let that = this;
            //缓存数据 关注系统 - 时间 改变时
            let localSumData = localStorage.getItem("monitorErrorSumData");
            if(localSumData && !isFource){
                that.sumData = JSON.parse(localSumData);
                that.sumData.isoverview = true;
                that.sumData.isperhour = true;
                //判断数据是否超时
                let tempHour = new Date().Format('hh');
                if(tempHour != that.sumData.createHour){
                    that.updateSumData();
                }
                else{
                    that.loadSumData();
                }
            }
            else{
                that.updateSumData();
            }
            
        },
        updateSumData(){
            let that = this;
            let currentTime = new Date().Format('hh');
            let params = {
                folowtype:'appcode',
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/queryoverview",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == 1){
                    that.sumData = res.data.data;
                    that.sumData.isoverview = true;
                    that.sumData.isperhour = true;
                    that.sumData.createHour = currentTime;
                    localStorage.setItem("monitorErrorSumData",JSON.stringify(that.sumData));
                    that.loadSumData();
         
                }
            }).catch(() => {
            });
        },
        loadSumData(){
            if(this.sumData.listfolows.length == 0){
                this.message.info("您还没有添加关注系统！请点击右上角“添加关注系统")
            }
            this.$refs.myFolowTable.getFolowData(this.currentTrange,this.sumData.listfolows,this.timeType);

        }

    },
    components:{
        sumP,
        qschart,
        zbpie,
        mtable,
        sysselecter,
        timeSelecter
    },
    mounted(){
        this.getOverview(false);
    }
};
</script>

<style lang="less" scoped>
.content{
  background-color: white; padding: 20px;min-width:900px;
}
.titleBox{
    width: 100%;
    position: relative;
    height: 40px;
    line-height:38px;
    padding:0 10px;
    border-bottom:1px solid lightgray;
}
.pageTitle{
    width:auto;
    height: 30px;
    float: left;
    color: #00c1de;
    font-size: 14px;
    cursor: default;
}

</style>
